import { Pipe, PipeTransform } from '@angular/core';

import { IBlockTimeItem } from '../block-time-report.model';

@Pipe({
  name: 'filterIbRepoAwaitingVerification',
})
export class FilterIbRepoAwaitingVerificationPipe implements PipeTransform {
  /**
   * When enabled, keeps only block time rows whose inbound reposition still awaits verification.
   */
  transform(records: IBlockTimeItem[] | null | undefined, showAwaitingVerificationOnly: boolean): IBlockTimeItem[] {
    if (!records?.length) {
      return [];
    }

    if (!showAwaitingVerificationOnly) {
      return records;
    }

    return records.filter((record: IBlockTimeItem) => record.ibRepoAwaitingVerification);
  }
}
